exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vuetify-editable-form-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-editable-form-card.vue"],"names":[],"mappings":"AACA,4BACE,kBAAoB,CACrB","file":"vuetify-editable-form-card.vue","sourcesContent":["\n.vuetify-editable-form-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2965ef8d","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vuetify-editable-form-card.vue
// module id = 632
// module chunks = 0 1 2 3 4 5